import { DataPlatformApi } from '@kcftech/data-platform-sdk';
import { dataPlatformClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

const indicatorFiltersQueryKey = ['data-platform-indicator-filters'] as const;

export function ensureIndicatorFilters() {
    return queryClient.ensureQueryData<DataPlatformApi.FilterResponse[]>({
        queryKey: indicatorFiltersQueryKey,
        queryFn: async () => {
            const response =
                await dataPlatformClient.indicatorFilters.getIndicatorFilters({
                    includeUserFilters: false,
                    includeGlobalFilters: true,
                    limit: 100,
                });
            return response.data;
        },
    });
}

export function ensureIndicatorFiltersByIds(ids: string[]) {
    return queryClient.ensureQueryData<DataPlatformApi.FilterResponse[]>({
        queryKey: [indicatorFiltersQueryKey, ids],
        queryFn: async () => {
            // TODO: Add support for filtering by custom filter IDs once the data platform supports it
            // const customFilters = await dataPlatformClient.indicatorFilters.getIndicatorFilters({
            //     filterIds: filter.customFilterIds,
            // });

            const customFilters: DataPlatformApi.FilterResponse[] = [];
            const promiseArray = ids.map((filterId) =>
                dataPlatformClient.indicatorFilters.getIndicatorFilter({ filterId }),
            );
            const results = await Promise.allSettled(promiseArray);

            for (const result of results) {
                if (result.status === 'fulfilled') {
                    customFilters.push(result.value);
                }
            }

            return customFilters;
        },
    });
}
